var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"reset footer"},[_c('a',{attrs:{"href":_vm.supportMailTo}},[_vm._v(" "+_vm._s(_vm.supportEmail)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('copy_right'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }